import {
	CAREER_OFFER_EVENTS,
	CAREER_OFFER_GOALS,
	type CareerOfferEvent,
	type CareerOfferGoal,
} from '../../career-offer-analytics/model/events.ts';

import { CAREER_OFFER_BANNER_PLACEMENT } from '../../career-offer-analytics/model/banner-campaign.ts';

type Analytics = {
	trackEvent: (event: CareerOfferEvent) => void;
	trackGoal: (goal: CareerOfferGoal, event: CareerOfferEvent) => void;
};

export function createCareerOfferBannerTracker(
	notificationId: string,
	analytics: Analytics,
	href: string,
) {
	const campaign = new URL(href, 'https://algocode.io').searchParams.get(
		'utm_campaign',
	);
	const context = {
		placement: CAREER_OFFER_BANNER_PLACEMENT,
		...(campaign && { campaign }),
		creative: notificationId,
		routing: 'direct' as const,
		entrypoint: 'promo',
	};
	let impressionSent = false;
	const impression = () => {
		if (impressionSent) return;
		impressionSent = true;
		const event = { name: CAREER_OFFER_EVENTS.PROMO_IMPRESSION, ...context };
		analytics.trackEvent(event);
		analytics.trackGoal(CAREER_OFFER_GOALS.BANNER_IMPRESSION, event);
	};

	return {
		impression,
		click() {
			impression();
			const event = { name: CAREER_OFFER_EVENTS.PROMO_CLICK, ...context };
			analytics.trackEvent(event);
			analytics.trackGoal(CAREER_OFFER_GOALS.BANNER_CLICK, event);
		},
	};
}
